import Vue, {VNode} from 'vue';
import {DirectiveBinding} from 'vue/types/options';

type PrototypeDefinition = HTMLElement & {
	clickOutsideEvent(event: Event): void
};

export default () => {
	Vue.directive('click-outside', {
		bind(el: HTMLElement, binding: DirectiveBinding, vnode: VNode): void {
			const clearString = (value: string) => value
				.replace(/\ /g, '')
				.replace(/\!/g, '');

			(el as PrototypeDefinition).clickOutsideEvent = (event: MouseEvent) => {
				const ternary = binding.expression.match(/([^?]*)\?([^:]*):([^;]*)|(\s*=\s*)[^;]*/g);

				if (!(el == event.target || el.contains(event.target as Node))) {
					if (ternary !== null) {
						const [statement, methods] = ternary[0].split('?');
						const [resolve, reject] = methods.split(':');

						const isStatementReversed = !!statement.match('!');

						// @ts-ignore
						if (typeof vnode.context[clearString(statement)] === 'undefined') {
							return;
						}

						// @ts-ignore
						if (vnode.context[clearString(statement)] === !isStatementReversed) {
							if (!resolve.match(/null/g)) {
								// @ts-ignore
								vnode.context[clearString(resolve)](event);
							}
						} else {
							if (!reject.match(/null/g)) {
								// @ts-ignore
								vnode.context[clearString(reject)](event);
							}
						}

						return;
					}

					// @ts-ignore
					vnode.context[binding.expression](event);
				}
			};

			setTimeout(() => {
				document.body.addEventListener('click', (el as PrototypeDefinition).clickOutsideEvent);
			}, 0);
		},
		unbind(el): void {
			document.body.removeEventListener('click', (el as PrototypeDefinition).clickOutsideEvent);
		}
	})
};
